import { createFileRoute } from '@tanstack/react-router'
import { StageDeliveryPage } from '@/lib/StageDeliveryPage'

export const Route = createFileRoute('/pipeline')({ component: SubmissionsPage })

function SubmissionsPage() {
  return <StageDeliveryPage stage="submitted" title="Submissions" subtitle="Roles whose shortlist has been submitted to the client." />
}
